import {type DomainMaybe} from '../types';

const LOG_SCALE_MIN = 1e-4;

export function getDomain(domain: DomainMaybe, logScale: boolean): DomainMaybe {
  return [
    getDomainPoint(domain[0], logScale),
    getDomainPoint(domain[1], logScale),
  ];
}

function getDomainPoint(
  point: number | null,
  logScale: boolean
): number | null {
  return point != null
    ? logScale
      ? Math.max(point, LOG_SCALE_MIN) // Log scale cannot handle 0 or negative values - clamp to a small positive number
      : point
    : null;
}
